import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Axios from 'axios';
import { Layout } from '../../configs/ui/constant';
import { useTheme } from '@material-ui/core/styles';
import debounce from 'debounce-promise';
import { LogToBackend } from '../../configs/helpers/LogToBackend';
const SearchRule = (props) => {
   const theme = useTheme();
   const {
      closeMenuOnSelect,
      onChange,
      isLoading,
      value,
      placeholder,
      isDisabled,
      defaultValue,
      name,
      title,
      options,
      alert,
      isMulti,
      onMenuOpen,
      defaultOptions,
      cacheOptions,
      inputValue,
   } = props;
   const customStyles = {
      input: (base) => ({
         ...base,
         fontFamily: `'DBHeavent', sans-serif `,
         '& input': {
            font: 'inherit',
         },
      }),
      control: (base, state) => ({
         ...base,
         borderRadius: '5px',
         boxShadow: '',
         fontFamily: `'DBHeavent', sans-serif `,
         // minHeight: '2.2rem',
         '&:focus': {
            border: '1.25px solid',
            borderColor: Layout.primary,
            boxShadow: '',
         },
         '&:hover': {
            border: '1.25px solid',
            borderColor: state.isFocused ? Layout.primary : Layout.primary,
            boxShadow: '',
         },
         border: alert ? '1.25px solid red' : '1.25px solid #d3d2d1',
      }),
      menu: (base) => ({
         ...base,
         backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#FFFFFF',
         // borderRadius: "5px",
      }),
      menuList: (base) => ({
         ...base,
      }),
      singleValue: (base) => ({
         ...base,
      }),
      indicatorSeparator: (base) => ({
         ...base,
         display: 'none',
      }),
      dropdownIndicator: (base) => ({
         ...base,
      }),
      placeholder: (base) => ({
         ...base,
      }),
      container: (base) => ({
         ...base,
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 999999,
      }),
   };
   const [rules, setRules] = useState([]);
   const getRules = (e) => {
      Axios.post('/GSB/dashboard/rule/SearchRule', {
         searchWord: e,
      })
         .then((resp) => {
            setRules(
               resp.data.map((category, idx) => ({
                  data: category,
                  value: category.ruleId,
                  label: `${category.ruleCode && category.ruleCode} : ${
                     category.ruleNameTh && category.ruleNameTh
                  }`,
               })),
            );
         })
         .catch((err) => {
            LogToBackend(err);
            // reject(err);
         })
         .finally(() => {});
   };
   useEffect(() => {
      getRules('');
   }, []);
   return (
      <Select
         styles={customStyles}
         // value={rules[0]} // default value
         options={rules}
         multi
         getOptionLabel={(option) => option.label}
         onInputChange={(val) => getRules(val)}
         onChange={onChange}
         placeholder={'เลือกหลักเกณฑ์'}
         isClearable
         isDisabled={isDisabled}
      />
   );
};

export default SearchRule;
